import { Button } from "antd";

import dayjs from "dayjs";
import { CSVLink } from "react-csv";
import { useIntl } from "react-intl";

const ExportModal = ({ data = [], title, close }: any) => {
  console.log(title);
  console.log(data);

  const DownloadCSVButton = ({ data, title }: any) => {
    console.log(data);
    const generateCSVData = () => {
      let filteredData;
      switch (title) {
        case "العملاء":
        case "عملاء":
        case "Clients":
          filteredData = data?.data?.map(
            ({
              first_name,
              last_name,
              email,
              gender,
              phone,
              preferred_staff_gender,
            }: any) => ({
              first_name,
              last_name,
              email,
              gender,
              preferred_staff_gender,
              phone,
            })
          );
          break;
        case "حجوزات":
        case "Reservations":
          filteredData = data?.map((e: any) => {
            const servicesObject: any = {};
            e.services.forEach((service: any, index: any) => {
              servicesObject[`service name ${index + 1}`] = service.name;
              servicesObject[
                `service price ${index + 1}`
              ] = `${service.selected_pricing_option.price} ريال سعودي`;
            });
            e.products.forEach((product: any, index: any) => {
              servicesObject[`product name ${index + 1}`] = product.name;
              servicesObject[
                `product price ${index + 1}`
              ] = `${product.amount} ريال سعودي`;
            });

            return {
              sale: e.id || "",
              date: e.date || "",
              start_time: e.start_time || "",
              finish_time: e.finish_time || "",
              cost: e.cost || "",
              tips_amount: e.tips_amount || "",
              status: e.status || "",
              team_member: e.team_member.name || "",
              location_id: e.location_id || "",
              ...servicesObject,
            };
          });
          break;
        case "أوردرات":
        case "orders":
        case "Orders":
          filteredData = data?.map((e: any) => {
            const servicesObject: any = {};
            e.items.forEach((service: any, index: any) => {
              servicesObject[`order name ${index + 1}`] = service.name;
              servicesObject[
                `order price ${index + 1} `
              ] = `${service.price} ريال سعودي`;
            });

            return {
              location_name: e.location_id || "",
              first_name: e.client_profile.first_name || "",
              last_name: e.client_profile.last_name || "",
              status: e.status || "",
              currency: e.currency,
              subtotal: e.subtotal,
              taxes: e.taxes,
              total: e.total,
              tip: e.tip,
              pay: e.pay,
              payment_type: e.payment_type,
              date: dayjs(e?.created_at).format("DD-MM-YYYY") || "",
              ...servicesObject,
            };
          });
          break;
        case "عضويات":
        case "Memberships":
        case "memberships":
          filteredData = data?.map((e: any) => {
            const servicesObject: any = {};
            e.items.forEach((service: any, index: any) => {
              servicesObject[`Membership name ${index + 1}`] = service.name;
              servicesObject[
                `sale price ${index + 1}`
              ] = `${service.price} ريال سعودي`;
            });

            return {
              sale: e?.id || "",
              first_name: e?.client_profile.first_name || "",
              last_name: e?.client_profile.last_name || "",
              date: dayjs(e?.created_at).format("DD-MM-YYYY") || "",
              payment_type: e?.payment_type || "",
              subtotal: e?.subtotal || "",
              status: e?.status || "",
              tips: e?.tips || 0,
              location_id: e?.location_id || "",
              ...servicesObject,
            };
          });
          break;
        default:
          filteredData = data?.map((e: any) => ({ ...e }));
          break;
      }

      return Array.isArray(filteredData) ? filteredData : [filteredData];
    };

    const csvData = generateCSVData();

    return (
      <CSVLink data={csvData} filename={`${title}.csv`} className="">
        <Button type="primary" className="mx-auto w-fit">
          {intl.formatMessage({
            id: "download",
          })}
        </Button>
      </CSVLink>
    );
  };

  const intl = useIntl();

  return (
    <div className="p-6 ">
      <div className="text-center bg-white rounded-lg">
        <div className="items-center justify-center w-full text-center lg:grid">
          <span className="px-8 mt-8 text-2xl font-semibold text-color-primary">
            {intl.formatMessage({ id: "downloadFile" })} {title}
          </span>
        </div>
        <div className="flex flex-col justify-center w-full gap-6 px-8 py-6">
          <div>
            <div className="text-[#020418] font-semibold mb-4">
              {intl.formatMessage({ id: "specialCsvFile" })}
              <span className="mx-1">{title}</span>
              <span> {intl.formatMessage({ id: "inlookFindr" })} </span>
            </div>
            <div className="text-[#75757E] font-normal">
              {intl.formatMessage({ id: "download_button_text" })}{" "}
              <span className="mx-1">{title}</span>
              {intl.formatMessage({ id: "click_download_file" })}
            </div>
          </div>
          <div className="flex items-center justify-center">
            <svg
              width="65"
              height="64"
              viewBox="0 0 65 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M58.1708 64H16.4308C13.3308 64 10.8008 61.48 10.8008 58.37V49.39C10.8008 48.85 11.2308 48.42 11.7708 48.42C12.3108 48.42 12.7408 48.85 12.7408 49.39V58.37C12.7408 60.4 14.4008 62.06 16.4308 62.06H58.1608C60.1908 62.06 61.8508 60.4 61.8508 58.37V16.4L48.9908 1.94H16.4308C14.4008 1.94 12.7408 3.59 12.7408 5.63V21.5C12.7408 22.04 12.3108 22.47 11.7708 22.47C11.2308 22.47 10.8008 22.04 10.8008 21.5V5.63C10.8008 2.53 13.3308 0 16.4308 0H49.4208C49.7008 0 49.9608 0.12 50.1408 0.33L63.5408 15.39C63.7008 15.57 63.7908 15.8 63.7908 16.03V58.37C63.7908 61.48 61.2708 64 58.1708 64Z"
                fill="#00086D"
              />
              <path
                d="M62.8192 17H49.4192C48.8792 17 48.4492 16.57 48.4492 16.03V0.97C48.4492 0.43 48.8792 0 49.4192 0C49.9592 0 50.3892 0.43 50.3892 0.97V15.06H62.8192C63.3592 15.06 63.7892 15.49 63.7892 16.03C63.7892 16.57 63.3592 17 62.8192 17Z"
                fill="#00086D"
              />
              <path
                d="M19.4511 44.56C16.9311 44.56 14.8711 42.5099 14.8711 39.9799C14.8711 39.4399 15.3011 39.0099 15.8411 39.0099C16.3811 39.0099 16.8111 39.4399 16.8111 39.9799C16.8111 41.4299 17.9911 42.6199 19.4511 42.6199C20.1511 42.6199 20.8111 42.3499 21.3111 41.8499C21.8111 41.3499 22.0811 40.69 22.0811 39.99C22.0811 38.57 20.9611 37.3799 19.5711 37.3499C17.0711 37.3499 15.0211 35.3 15.0211 32.77C15.0211 31.55 15.5011 30.4 16.3611 29.54C17.2211 28.68 18.3711 28.2 19.5911 28.2C20.8111 28.2 21.9611 28.68 22.8211 29.54C23.6811 30.4 24.1611 31.5499 24.1611 32.7799C24.1611 33.3199 23.7311 33.75 23.1911 33.75C22.6511 33.75 22.2211 33.3199 22.2211 32.7799C22.2211 32.0799 21.9511 31.41 21.4511 30.92C20.9511 30.42 20.2911 30.15 19.5911 30.15C18.8911 30.15 18.2211 30.42 17.7311 30.92C17.2311 31.42 16.9611 32.0799 16.9611 32.7799C16.9611 34.2299 18.1411 35.4199 19.5911 35.4199C22.0411 35.4699 24.0211 37.53 24.0111 40C24.0111 41.22 23.5311 42.37 22.6711 43.2299C21.8211 44.08 20.6711 44.56 19.4511 44.56Z"
                fill="#00086D"
              />
              <path
                d="M32.3495 43.64C32.3495 43.64 32.3395 43.64 32.3295 43.64C31.9295 43.63 31.5795 43.39 31.4395 43.01L26.6495 30.43C26.4595 29.93 26.7095 29.37 27.2095 29.18C27.7095 28.99 28.2695 29.24 28.4595 29.74L32.3795 40.05L36.6795 29.72C36.8895 29.23 37.4495 28.99 37.9495 29.2C38.4395 29.41 38.6795 29.97 38.4695 30.47L33.2295 43.05C33.0995 43.4 32.7395 43.64 32.3495 43.64Z"
                fill="#00086D"
              />
              <path
                d="M6.85094 44.3899C3.74094 44.3899 1.21094 41.8599 1.21094 38.7499V33.9999C1.21094 30.8899 3.74094 28.3599 6.85094 28.3599C8.63094 28.3599 10.3209 29.2099 11.3809 30.6399L11.5609 30.8799C11.8809 31.3099 11.7909 31.9199 11.3609 32.2399C10.9309 32.5599 10.3209 32.4699 10.0009 32.0399L9.82094 31.7999C9.13094 30.8699 8.02094 30.3099 6.85094 30.3099C4.81094 30.3099 3.15094 31.9699 3.15094 34.0099V38.7699C3.15094 40.8099 4.81094 42.4699 6.85094 42.4699C8.02094 42.4699 9.13094 41.9099 9.82094 40.9799L10.0009 40.7399C10.3209 40.3099 10.9309 40.2199 11.3609 40.5399C11.7909 40.8599 11.8809 41.4699 11.5609 41.8999L11.3809 42.1399C10.3209 43.5399 8.62094 44.3899 6.85094 44.3899Z"
                fill="#00086D"
              />
            </svg>
          </div>
          {DownloadCSVButton({ data, title })}
        </div>
      </div>
    </div>
  );
};

export default ExportModal;
